import { InjectionToken } from "@angular/core";

export const SESSION_STORAGE_PREFIX = new InjectionToken("SESSION_STORAGE_PREFIX");
